import React from 'react'
import Sidebar from '../Sidebar/Sidebar'
import './Member.css'
import Navbar from './Navbar'
import Ordertable from './Ordertable'
import Header from './header'

function Member() {
  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <div className="shrink-0">
        <Navbar />
      </div>
      <div className="flex flex-1 overflow-hidden items-start">
        <div className="shrink-0 overflow-y-auto h-full">
          <Sidebar />
        </div>
        <div className="flex flex-col flex-1 max-h-full overflow-hidden">
          <div className="shrink-0">
            <Header title='Agent' />
          </div>
          <div className="flex-1 overflow-y-auto">
            <Ordertable />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Member
